module.exports = __webpack_public_path__ + "img/img006.b63a9d5f.png";